<template>
    <div class='yi-row-5'>
        <div>
            <div class='c-link-class'>
                <div class='title'>
                    <img src='/static/image/index/icon-about.png'>
                    关于我们
                </div>
                <div class='content'>
                    <div @click='toUrl("/about")'>关于应答</div>
                    <div @click='toUrl("/about/contact")'>联系我们</div>
                    <div @click='toUrl("/about/contact")'>商务合作</div>
                </div>
            </div>
        </div>
        <div>
            <div class='c-link-class'>
                <div class='title'>
                    <img src='/static/image/index/icon-game.png'>
                    应答游戏
                </div>
                <div class='content'>
                    <div @click='toM2Url("/")'>手机游戏</div>
                    <div @click='toM2Url("/")'>客户端游戏</div>
                    <div @click='toM2Url("/")'>网页游戏</div>
                </div>
            </div>
        </div>
        <div>
            <div class='c-link-class'>
                <div class='title'>
                    <img src='/static/image/index/icon-register.png'>
                    注册账户
                </div>
                <div class='content'>
                    <div @click='toUrl("/register")'>注册通行证</div>
                    <div @click='toUrl("/service/faq?type=repass")'>找回密码</div>
                </div>
            </div>
        </div>
        <div>
            <div class='c-link-class'>
                <div class='title'>
                    <img src='/static/image/index/icon-user.png'>
                    账户管理
                </div>
                <div class='content'>
                    <div @click='toUrl("/recharge")'>充值中心</div>
                    <div @click='toUrl("/service")'>安全中心</div>
                    <div @click='toUrl("/service")'>客服中心</div>
                </div>
            </div>
        </div>
        <div>
            <div class='c-link-class'>
                <div class='title'>
                    <img src='/static/image/index/icon-service.png'>
                    客服热线
                </div>
                <div class='content' style='padding-left:12%;'>
                    <div>电话：023-86062306</div>
                    <div>QQ：22144461</div>
                    <div>Email：kf@unnda.com</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
import ScrollReveal from 'scrollreveal'
export default {
    methods: {
        toUrl(url) {
            Common.toUrl(url)
            return true
        },

        toM2Url(url) {
            Common.toM2Url(url)
            return true
        }
    },
    mounted() {
        // var show = ScrollReveal({
        //     'origin' : 'bottom',
        //     'distance' : '100px',
        //     'duration' : 400,
        //     'delay' : 400
        // });
        // $('.link-class').each(function(k){
        //     show.reveal($(this), {
        //         delay : k * 200 + 200
        //     })
        // })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/util/Link.vue